import CloseIcon from '@mui/icons-material/Close';
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material';

interface ReviewDialogHeaderProps {
  companyName: string;
  handleClose: () => void;
  isDeepDive?: boolean;
}

function ReviewDialogHeader(props: ReviewDialogHeaderProps) {
  const { companyName, handleClose, isDeepDive } = props;

  return (
    <AppBar
      sx={{
        position: 'relative',
        backgroundColor: 'rgb(0, 158, 219)',
        color: 'white',
      }}
    >
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>

        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
          Leave a {isDeepDive ? <strong>Deal Retro</strong> : 'Deal Retro'} for {companyName}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default ReviewDialogHeader;
